import { createValidations, Validation, ValidationHandler } from './validator';

export type ComposeValidation<T> = (validations: Validation<T>[]) => Validation<T>;

export const createCompose =
  <T>(chain: ValidationHandler<T>[]) =>
  (validations: Validation<T>[]) =>
    createValidations<T>([
      ...chain,
      async (value) => {
        const results = await Promise.all(validations.map(async (x) => x.results(value)));
        return results.flat();
      }
    ]);
